/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuInputRange_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuInputRangeCurrency_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuInputRangeCurrency_searchBrowse = {|
  +appliedFilters: ?$ReadOnlyArray<?{|
    +name: ?string
  |}>,
  +$fragmentRefs: SbSharedRefineMenuInputRange_searchBrowse$ref,
  +$refType: SbSharedRefineMenuInputRangeCurrency_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuInputRangeCurrency_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRange_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e264c262e9ad1a37c7ab63c23113cbc1';
module.exports = node;
